import React from 'react';
import { DrawerProps as MantineDrawerProps } from '@mantine/core';
import { HudIcon, IconType } from '../Icons/HudIcons';
import { IconButton } from '../Button/IconButton';
import * as Styled from './Drawer.styles';

export interface DrawerProps extends MantineDrawerProps {
  opened: boolean;
  onClose: () => void;

  title: string | React.ReactNode;
  icon?: IconType;
  size?: string | number;

  footer?: React.ReactNode;
  role?: string;
  'aria-label'?: string;
}

export function Drawer({
  opened,
  onClose,
  title,
  icon,
  size,
  children,
  footer,
  role,
  'aria-label': ariaLabel,
  ...rest
}: DrawerProps) {
  const hasHeader = title || icon;

  return (
    <Styled.StyledDrawer
      opened={opened}
      onClose={onClose}
      title={hasHeader && <DrawerHeader title={title} icon={icon} onClose={onClose} />}
      position="right"
      size={size}
      scrollAreaComponent={Styled.FullHeightScrollArea}
      $withFooter={!!footer}
      withCloseButton={false}
      role={role}
      aria-label={ariaLabel}
      aria-expanded={opened}
      {...rest}
    >
      {footer && <Styled.FooterContainer>{footer}</Styled.FooterContainer>}
      {children}
    </Styled.StyledDrawer>
  );
}

function DrawerHeader({
  title,
  icon,
  onClose,
}: {
  title: string | React.ReactNode;
  icon?: IconType;
  onClose?: () => void;
}) {
  return (
    <Styled.HeaderContainer>
      {icon && <HudIcon icon={icon} size="24px" />}
      <div className="drawerTitle">{title}</div>
      <IconButton icon="other.close" variant="outlined" size="sm" onClick={onClose} />
    </Styled.HeaderContainer>
  );
}
